import React from 'react';
import './social.css';
import {SOCIAL_TITLE} from '../../constants';
import instagram from './instagram.svg';
import facebook from './facebook.svg';
import google from './google.svg';
import twitter from './twitter.svg';
import youtube from './youtube.svg';
import dribbble from './dribbble.svg';
import pinterest from './pinterest.svg';

const SOCIAL = [
	{title: 'instagram', img: instagram},
	{title: 'facebook', img: facebook},
	{title: 'google', img: google},
	{title: 'twitter', img: twitter},
	{title: 'youtube', img: youtube},
	{title: 'dribbble', img: dribbble},
	{title: 'pinterest', img: pinterest}];

const Social = () => {
	return (
		<div className="social">
			<h3 className="social__title">{SOCIAL_TITLE}</h3>
			<div className="social__list">
				{SOCIAL.map((icon) => {
					return (
						<div key={'social-icon-' + icon.title} className="social__item">
							<img src={icon.img}
							     className={"social__icon social__icon--" + icon.title}
							     alt={"logo" + icon.title}/>
						</div>
					)
				})}
			</div>
		</div>
	);
};

export default Social;



// WEBPACK FOOTER //
// ./src/components/Social/Social.js